export default __webpack_public_path__ + "static/media/YAS0670.34I-31180_-23156_0.3012f54d.jpg";